import { render, staticRenderFns } from "./CalendarStats.vue?vue&type=template&id=375aff88&lang=pug&"
import script from "./CalendarStats.vue?vue&type=script&lang=js&"
export * from "./CalendarStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports